import { merge } from 'lodash';
import { ProductType } from '../enums';
import { applySalePrice, getProductByProductId } from '../utils/products';

import { buildCloudPayQuery } from '../utils/query';

/**
 * Handles the first initial bootstrap app load
 *
 * @param {Object} [options]
 * @returns {QueryConfig}
 */
export const bootstrapAppRequest = buildCloudPayQuery(
  ({ body }) => ({
    body,
    url: `/client/bootstrap`,
    transform: (bootstrap) => {
      const { client, subscriber, user, subscriptions, latestSubscription } = bootstrap;

      const planSubscription = subscriptions?.filter(subscription => getProductByProductId(subscription.productId, client.products)?.productType === ProductType.PLAN);
      const addOnSubscriptions = subscriptions?.filter(subscription => getProductByProductId(subscription.productId, client.products)?.productType === ProductType.ADD_ON);
      const activePlan = planSubscription?.find(subscription => subscription.mainSubscription) || planSubscription?.[0];

      delete bootstrap.products;
      delete bootstrap.user;

      // if user is in the same country as the ip, we filter the products  by country
      // otherwise we hide all products
      const products = client.products;
      // let products = [];
      // const country = activePlan?.country || user.country;
      // if (user.ipCountry === country) {
      //   products = client.products.filter(product => product.countries.includes(user.ipCountry));
      // }

      return {
        bootstrap: client,
        products: {
          // this product entity will work our ui
          list: applySalePrice(products).map(item => ({
            ...item,
            originalCurrency: item.currency,
            currency: client.exchangeRate?.to || item.currency,
            grossPriceToShow: item.grossPrice && client.exchangeRate?.from === 'USD'
              ? (item.grossPrice * (client.exchangeRate?.rate || 1))
              : (item.grossPrice / (client.exchangeRate?.rate || 1)),
            priceToShow: client.exchangeRate?.from === 'USD'
              ? (item.price * (client.exchangeRate?.rate || 1))
              : (item.price / (client.exchangeRate?.rate || 1))
          })).sort((a, b) => a.order - b.order)
        },
        subscriber,
        subscriptions: {
          all: subscriptions,
          addOns: addOnSubscriptions,
          latestSubscription,
          activePlan
        },
        exchangeRate: client.exchangeRate,
        user
      };
    },
    update: {
      bootstrap: merge,
      products: merge,
      addOns: merge,
      subscriber: merge,
      subscriptions: merge,
      user: merge
    },
    options: {
      method: 'POST'
    }
  })
);
